/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { Bet } from "./Bet";

export class BetFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<Bet> {
    return super.deploy(overrides || {}) as Promise<Bet>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Bet {
    return super.attach(address) as Bet;
  }
  connect(signer: Signer): BetFactory {
    return super.connect(signer) as BetFactory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Bet {
    return new Contract(address, _abi, signerOrProvider) as Bet;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "Sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "message",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "Comments",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_tokensInExaEs",
        type: "uint256",
      },
    ],
    name: "TransferES",
    type: "event",
  },
  {
    inputs: [],
    name: "Incentive",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "message",
        type: "string",
      },
    ],
    name: "addComments",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bettorBetAmountInExaEsByChoice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "bettorHasClaimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "category",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "creationTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dayswappers",
    outputs: [
      {
        internalType: "contract IDayswappers",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "description",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "downVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "downvote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_choice",
        type: "uint8",
      },
    ],
    name: "endBet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "endedBy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_choice",
        type: "uint8",
      },
    ],
    name: "enterBet",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "finalResult",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "getNumberOfChoiceBettors",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner1",
        type: "address",
      },
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "_category",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_subCategory",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_minimumBetInExaEs",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_prizePercentPerThousand",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "_incentive",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "_isDrawPossible",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_pauseTimestamp",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_kycDapp",
        type: "address",
      },
      {
        internalType: "string",
        name: "_other",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isDrawPossible",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "kycDapp",
    outputs: [
      {
        internalType: "contract IKycDapp",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumBetInExaEs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nrtManager",
    outputs: [
      {
        internalType: "contract INRTManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "other",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "prepaidEs",
    outputs: [
      {
        internalType: "contract IPrepaidEs",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "prizePercentPerThousand",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "randomnessManager",
    outputs: [
      {
        internalType: "contract RandomnessManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rejectBet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddressStrict",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsername",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsernameStrict",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bettorAddress",
        type: "address",
      },
    ],
    name: "seeWinnerPrize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_kycDapp",
        type: "address",
      },
    ],
    name: "setKycDapp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "subCategory",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyClub",
    outputs: [
      {
        internalType: "contract ITimeAllyClub",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyManager",
    outputs: [
      {
        internalType: "contract ITimeAllyManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyPromotionalBucket",
    outputs: [
      {
        internalType: "contract ITimeAllyPromotionalBucket",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "totalBetTokensInExaEsByChoice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalContractBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPrize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "upVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "upvote",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validatorManager",
    outputs: [
      {
        internalType: "contract IValidatorManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_bettorAddress",
        type: "address",
      },
    ],
    name: "withdrawPrize",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "0x60e06040526000608081815260a082905260c09190915262000026906010906003620000c3565b50604080516060810182526000808252602082018190529181019190915262000054906013906003620000c3565b503480156200006257600080fd5b5060006200006f620000bf565b600080546001600160a01b0319166001600160a01b0383169081178255604051929350917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a35062000122565b3390565b8260038101928215620000f9579160200282015b82811115620000f9578251829060ff16905591602001919060010190620000d7565b50620001079291506200010b565b5090565b5b808211156200010757600081556001016200010c565b61233080620001326000396000f3fe6080604052600436106102185760003560e01c80630a9859301461021d5780630d541ecb146102445780630df5202f1461027757806311dc45c9146102a8578063164e6280146102d05780631b363939146103035780631d849b30146103185780631e3ec204146103425780631f70693c1461036c578063208b38041461039f578063257204b2146103b4578063380edf49146103de5780634b623e63146103f357806353ed2a8d1461043a5780635d71dad81461045a578063602ad4901461046f57806367b48b18146104a8578063697d2c07146104bd5780636a14920a146104e8578063722d2b3e146105125780637284e4161461052757806382b1ad50146105b157806385295877146105c65780638da5cb5b146105db57806392d7727c146105f057806398b1a44d14610605578063a1b9e1e614610638578063a7017b521461064d578063a85adeab14610662578063a8df84df14610677578063ad84f3411461068c578063b2bdfa7b146106a1578063b3311086146106b6578063bac03cd7146106cb578063bf8c3144146106e0578063d9d6f1aa146106f5578063dccc1b0814610880578063de6bc74314610895578063deb97c8a146108aa578063e39fddc7146108bf578063e8217556146108d4578063ec7690bf14610985578063ef430aa6146109b2578063f2fde38b146109c7578063f3a8286f146109fa578063f456795114610a0f578063fe55bde914610a24575b600080fd5b34801561022957600080fd5b50610232610a39565b60408051918252519081900360200190f35b34801561025057600080fd5b506102326004803603602081101561026757600080fd5b50356001600160a01b0316610a3f565b34801561028357600080fd5b5061028c610a8f565b604080516001600160a01b039092168252519081900360200190f35b6102ce600480360360208110156102be57600080fd5b50356001600160a01b0316610aad565b005b3480156102dc57600080fd5b50610232600480360360208110156102f357600080fd5b50356001600160a01b0316610d14565b34801561030f57600080fd5b506102ce610dae565b34801561032457600080fd5b5061028c6004803603602081101561033b57600080fd5b5035610f27565b34801561034e57600080fd5b506102326004803603602081101561036557600080fd5b5035610f7a565b34801561037857600080fd5b506102326004803603602081101561038f57600080fd5b50356001600160a01b0316610f91565b3480156103ab57600080fd5b5061028c611014565b3480156103c057600080fd5b50610232600480360360208110156103d757600080fd5b503561102d565b3480156103ea57600080fd5b5061023261103d565b3480156103ff57600080fd5b506104266004803603602081101561041657600080fd5b50356001600160a01b0316611043565b604080519115158252519081900360200190f35b6102ce6004803603602081101561045057600080fd5b503560ff16611058565b34801561046657600080fd5b5061042661143b565b34801561047b57600080fd5b506102326004803603604081101561049257600080fd5b506001600160a01b038135169060200135611444565b3480156104b457600080fd5b5061028c611469565b3480156104c957600080fd5b506104d2611478565b6040805160ff9092168252519081900360200190f35b3480156104f457600080fd5b5061028c6004803603602081101561050b57600080fd5b5035611487565b34801561051e57600080fd5b5061028c6114d3565b34801561053357600080fd5b5061053c6114f1565b6040805160208082528351818301528351919283929083019185019080838360005b8381101561057657818101518382015260200161055e565b50505050905090810190601f1680156105a35780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b3480156105bd57600080fd5b5061023261157f565b3480156105d257600080fd5b5061053c611585565b3480156105e757600080fd5b5061028c6115e0565b3480156105fc57600080fd5b506102ce6115ef565b34801561061157600080fd5b506102ce6004803603602081101561062857600080fd5b50356001600160a01b03166115fa565b34801561064457600080fd5b506102326116bc565b34801561065957600080fd5b5061028c6116c2565b34801561066e57600080fd5b506102326116eb565b34801561068357600080fd5b506102ce6116f1565b34801561069857600080fd5b506102326116fc565b3480156106ad57600080fd5b5061028c611702565b3480156106c257600080fd5b50610232611711565b3480156106d757600080fd5b50610232611717565b3480156106ec57600080fd5b5061028c61171b565b34801561070157600080fd5b506102ce600480360361016081101561071957600080fd5b6001600160a01b038235169190810190604081016020820135600160201b81111561074357600080fd5b82018360208201111561075557600080fd5b803590602001918460018302840111600160201b8311171561077657600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929560ff8535811696602087013582169660408101359650606081013595506080810135909216935060a082013515159260c0830135926001600160a01b0360e08201351692906101208101906101000135600160201b81111561080c57600080fd5b82018360208201111561081e57600080fd5b803590602001918460018302840111600160201b8311171561083f57600080fd5b91908080601f01602080910402602001604051908101604052809392919081815260200183838082843760009201919091525092955061173b945050505050565b34801561088c57600080fd5b5061028c61185c565b3480156108a157600080fd5b506104d2611877565b3480156108b657600080fd5b50610232611880565b3480156108cb57600080fd5b5061028c611886565b3480156108e057600080fd5b506102ce600480360360208110156108f757600080fd5b810190602081018135600160201b81111561091157600080fd5b82018360208201111561092357600080fd5b803590602001918460018302840111600160201b8311171561094457600080fd5b91908080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250929550611895945050505050565b34801561099157600080fd5b506102ce600480360360208110156109a857600080fd5b503560ff1661194a565b3480156109be57600080fd5b506104d2611d34565b3480156109d357600080fd5b506102ce600480360360208110156109ea57600080fd5b50356001600160a01b0316611d42565b348015610a0657600080fd5b506104d2611db5565b348015610a1b57600080fd5b5061028c611dc5565b348015610a3057600080fd5b5061028c611ddd565b60065481565b600080610a4b83610f91565b905080610a895760405162461bcd60e51b815260040180806020018281038252602a8152602001806121d6602a913960400191505060405180910390fd5b92915050565b6000610aa86a27292a2fa6a0a720a3a2a960a91b610f27565b905090565b6000600c5411610aee5760405162461bcd60e51b81526004018080602001828103825260248152602001806122006024913960400191505060405180910390fd5b3360009081526018602052604090205460ff1615610b4d576040805162461bcd60e51b81526020600482015260176024820152762132ba1d1021a0a72727aa2fa1a620a4a6afa0a3a0a4a760491b604482015290519081900360640190fd5b6001600160a01b0381163314610b945760405162461bcd60e51b81526004018080602001828103825260278152602001806121af6027913960400191505060405180910390fd5b336000908152601760205260408120600854600160a01b900460ff1660038110610bba57fe5b015411610bf85760405162461bcd60e51b81526004018080602001828103825260218152602001806122946021913960400191505060405180910390fd5b600854600090610c5890601090600160a01b900460ff1660038110610c1957fe5b0154601654336000908152601760205260409020600854610c52929190600160a01b900460ff1660038110610c4a57fe5b015490611dfc565b90611e5c565b336000908152601860209081526040808320805460ff19166001179055601790915281206008549293509091600160a01b900460ff1660038110610c9857fe5b01556040516001600160a01b0383169082156108fc029083906000818181858888f19350505050158015610cd0573d6000803e3d6000fd5b506040805182815290516001600160a01b038416917fd0d5fa64f70cc6d03909b4b948368d3baa5b331c6f80cd8a9647d2db4f17bb99919081900360200190a25050565b600080600c5411610d565760405162461bcd60e51b81526004018080602001828103825260258152602001806122246025913960400191505060405180910390fd5b600854610a8990601090600160a01b900460ff1660038110610d7457fe5b01546016546001600160a01b0385166000908152601760205260409020600854610c52929190600160a01b900460ff1660038110610c4a57fe5b6002546040805163033b005d60e41b815233600482015290516001600160a01b03909216916333b005d091602480820192602092909190829003018186803b158015610df957600080fd5b505afa158015610e0d573d6000803e3d6000fd5b505050506040513d6020811015610e2357600080fd5b5051610e64576040805162461bcd60e51b815260206004820152601860248201526000805160206122b5833981519152604482015290519081900360640190fd5b60025460408051637fca256560e01b815230600482015290516001600160a01b0390921691637fca256591602480820192602092909190829003018186803b158015610eaf57600080fd5b505afa158015610ec3573d6000803e3d6000fd5b505050506040513d6020811015610ed957600080fd5b505115610f24576040805162461bcd60e51b81526020600482015260146024820152734265745f415050524f5645445f414c524541445960601b604482015290519081900360640190fd5b33ff5b600080610f3383611487565b90506001600160a01b038116610a895760405162461bcd60e51b81526004018080602001828103825260268152602001806122d56026913960400191505060405180910390fd5b60108160038110610f8a57600080fd5b0154905081565b600154604080516307dc1a4f60e21b81526001600160a01b03848116600483015291516000939290921691631f70693c91602480820192602092909190829003018186803b158015610fe257600080fd5b505afa158015610ff6573d6000803e3d6000fd5b505050506040513d602081101561100c57600080fd5b505192915050565b6000610aa86a444159535741505045525360a81b610f27565b60138160038110610f8a57600080fd5b600d5481565b60186020526000908152604090205460ff1681565b60025460408051637fca256560e01b815230600482015290516001600160a01b0390921691637fca256591602480820192602092909190829003018186803b1580156110a357600080fd5b505afa1580156110b7573d6000803e3d6000fd5b505050506040513d60208110156110cd57600080fd5b5051611117576040805162461bcd60e51b815260206004820152601460248201527310995d17d393d517d054141493d5915117d6515560621b604482015290519081900360640190fd5b600b543490421061116f576040805162461bcd60e51b815260206004820152601d60248201527f43616e6e6f7420656e7465722061667465722070617573652074696d65000000604482015290519081900360640190fd5b6009546001600160a01b0316156111c2576040805162461bcd60e51b815260206004820152601260248201527110995d0e881053149150511657d15391115160721b604482015290519081900360640190fd5b600d548110156112035760405162461bcd60e51b815260040180806020018281038252602a81526020018061226a602a913960400191505060405180910390fd5b6002546001600160a01b0316630366e7f46112246064610c52856001611dfc565b600854604080516001600160e01b031960e086901b1681523360048201526001600160a01b039092166024830152604482018690526001606483015251608480830192600092919082900301818588803b15801561128157600080fd5b505af1158015611295573d6000803e3d6000fd5b505050505060006112b56064610c52606385611dfc90919063ffffffff16565b905060028360ff1611806112da57508260ff1660021480156112da575060055460ff16155b1561132b576040805162461bcd60e51b815260206004820152601c60248201527b546869732063686f696365206973206e6f7420617661696c61626c6560201b604482015290519081900360640190fd5b611348600160138560ff166003811061134057fe5b015490611e9b565b60138460ff166003811061135857fe5b015561136e81601060ff86166003811061134057fe5b60108460ff166003811061137e57fe5b01553360009081526017602052604090206113a390829060ff86166003811061134057fe5b33600090815260176020526040902060ff8516600381106113c057fe5b01556002546040805163edef946760e01b815233600482015260ff861660248201526044810184905290516001600160a01b039092169163edef94679160648082019260009290919082900301818387803b15801561141e57600080fd5b505af1158015611432573d6000803e3d6000fd5b50505050505050565b60055460ff1681565b6017602052816000526040600020816003811061146057600080fd5b01549150829050565b6001546001600160a01b031690565b60055462010000900460ff1681565b6001546040805163350a490560e11b81526004810184905290516000926001600160a01b031691636a14920a916024808301926020929190829003018186803b158015610fe257600080fd5b6000610aa86f2a24a6a2a0a6262cafa6a0a720a3a2a960811b610f27565b6003805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156115775780601f1061154c57610100808354040283529160200191611577565b820191906000526020600020905b81548152906001019060200180831161155a57829003601f168201915b505050505081565b60165481565b6004805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156115775780601f1061154c57610100808354040283529160200191611577565b6000546001600160a01b031690565b600680546001019055565b6002546040805163033b005d60e41b815233600482015290516001600160a01b03909216916333b005d091602480820192602092909190829003018186803b15801561164557600080fd5b505afa158015611659573d6000803e3d6000fd5b505050506040513d602081101561166f57600080fd5b50516116b0576040805162461bcd60e51b815260206004820152601860248201526000805160206122b5833981519152604482015290519081900360640190fd5b6116b981611ef3565b50565b60075481565b6000610aa87a151253515053131657d41493d353d51253d3905317d09550d2d155602a1b610f27565b600c5481565b600780546001019055565b600b5481565b6008546001600160a01b031681565b600a5481565b4790565b6000610aa8712920a72227a6a722a9a9afa6a0a720a3a2a960711b610f27565b6008546001600160a01b031615611794576040805162461bcd60e51b815260206004820152601860248201527710995d0e881053149150511657d25392551250531256915160421b604482015290519081900360640190fd5b600880546001600160a01b0319166001600160a01b038d1617905589516117c29060039060208d019061210d565b506005805460ff8a8116620100000262ff0000198d83166101000261ff00198a151560ff199687161716171617909255600d899055600e889055600280546001600160a01b0319163317905542600a55600b85905560006006819055600755600f80549288169290911691909117905561183b82611ef3565b805161184e90600490602084019061210d565b505050505050505050505050565b6000610aa86c2a24a6a2a0a6262cafa1a62aa160991b610f27565b600f5460ff1681565b600e5481565b6009546001600160a01b031681565b7fb37b709b55731a6d6f045a21461376b3dad97e9602d8a0cfb466175c81a1ac7333824260405180846001600160a01b0316815260200180602001838152602001828103825284818151815260200191508051906020019080838360005b8381101561190b5781810151838201526020016118f3565b50505050905090810190601f1680156119385780820380516001836020036101000a031916815260200191505b5094505050505060405180910390a150565b6002546040805163033b005d60e41b815233600482015290516001600160a01b03909216916333b005d091602480820192602092909190829003018186803b15801561199557600080fd5b505afa1580156119a9573d6000803e3d6000fd5b505050506040513d60208110156119bf57600080fd5b5051611a00576040805162461bcd60e51b815260206004820152601860248201526000805160206122b5833981519152604482015290519081900360640190fd5b6009546001600160a01b031615611a53576040805162461bcd60e51b815260206004820152601260248201527110995d0e881053149150511657d15391115160721b604482015290519081900360640190fd5b60028160ff161080611a7557508060ff166002148015611a75575060055460ff165b15611a97576008805460ff60a01b1916600160a01b60ff841602179055611ae0565b6040805162461bcd60e51b81526020600482015260196024820152784265743a2043484f4943455f4e4f545f415641494c41424c4560381b604482015290519081900360640190fd5b600980546001600160a01b0319163317905542600c55600e54611b13906103e890610c5290611b0d611717565b90611dfc565b6016819055600090611b2d90611b27611717565b90611f15565b600254600f549192506001600160a01b031690630366e7f490611b5b90606490610c5290869060ff16611dfc565b600854600f54604080516001600160e01b031960e087901b1681526001600160a01b0390931660048401523360248401526044830187905260ff909116606483015251608480830192600092919082900301818588803b158015611bbe57600080fd5b505af1158015611bd2573d6000803e3d6000fd5b5050600854600f546001600160a01b0390911693506108fc9250611c079150606490610c5290869060ff908116840316611dfc565b6040518115909202916000818181858888f19350505050158015611c2f573d6000803e3d6000fd5b5060028054600954601654604051630c449d0160e41b81526001600160a01b039283166004820181815260ff89166024840152604483018490526080606484019081526003805460001960018216156101000201169890980460848501819052959096169663c449d0109692958a959491939160a4019084908015611cf55780601f10611cca57610100808354040283529160200191611cf5565b820191906000526020600020905b815481529060010190602001808311611cd857829003601f168201915b505095505050505050600060405180830381600087803b158015611d1857600080fd5b505af1158015611d2c573d6000803e3d6000fd5b505050505050565b600554610100900460ff1681565b611d4a611f57565b6000546001600160a01b03908116911614611dac576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2043414c4c45525f49535f4e4f545f5448455f4f574e4552604482015290519081900360640190fd5b6116b981611f5b565b600854600160a01b900460ff1681565b6000610aa869505245504149445f455360b01b610f27565b6000610aa8702b20a624a220aa27a92fa6a0a720a3a2a960791b610f27565b600082611e0b57506000610a89565b82820282848281611e1857fe5b0414611e555760405162461bcd60e51b81526004018080602001828103825260218152602001806122496021913960400191505060405180910390fd5b9392505050565b6000611e5583836040518060400160405280601a815260200179536166654d6174683a206469766973696f6e206279207a65726f60301b815250612011565b600082820183811015611e55576040805162461bcd60e51b815260206004820152601b60248201527a536166654d6174683a206164646974696f6e206f766572666c6f7760281b604482015290519081900360640190fd5b600180546001600160a01b0319166001600160a01b0392909216919091179055565b6000611e5583836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f7700008152506120b3565b3390565b6001600160a01b038116611fb6576040805162461bcd60e51b815260206004820152601f60248201527f4f776e61626c653a204e45575f4f574e45525f49535f5a45524f5f4144445200604482015290519081900360640190fd5b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b0319166001600160a01b0392909216919091179055565b6000818361209d5760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b8381101561206257818101518382015260200161204a565b50505050905090810190601f16801561208f5780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b5060008385816120a957fe5b0495945050505050565b600081848411156121055760405162461bcd60e51b815260206004820181815283516024840152835190928392604490910191908501908083836000831561206257818101518382015260200161204a565b505050900390565b828054600181600116156101000203166002900490600052602060002090601f0160209004810192826121435760008555612189565b82601f1061215c57805160ff1916838001178555612189565b82800160010185558215612189579182015b8281111561218957825182559160200191906001019061216e565b50612195929150612199565b5090565b5b80821115612195576000815560010161219a56fe4265743a204f4e4c595f424554544f525f43414e5f434c41494d5f4849535f57494e4e494e475352656769737472793a205245534f4c5645445f4e554c4c5f555345524e414d455f494e5f5354524943544265743a2043414e4e4f545f57495448445241575f4245464f52455f454e445f54494d454265743a2043414e4e4f545f5345455f5052495a455f4245464f52455f4245545f454e4453536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f7742657474696e6720746f6b656e732073686f756c64206265206d6f7265207468616e206d696e696d756d4265743a2043414c4c45525f53484f554c445f484156455f415f42455454494e474265743a204f4e4c595f41444d494e5f43414e5f43414c4c000000000000000052656769737472793a205245534f4c5645445f5a45524f5f414444525f494e5f535452494354a264697066735822122036003ccca49ddbb6bec0eb2cac1f7fc77c0d37870a26d3fa64967f98dccdbcfd64736f6c63430007050033";
